import { createBox } from "@shopify/restyle";
import type { Theme } from "@theme";
import { LinearGradient, LinearGradientProps } from "expo-linear-gradient";
import Animated, { AnimatedProps } from "react-native-reanimated";
import type { GradientPosition } from "types/gradient";

const AnimatedLinearGradient = Animated.createAnimatedComponent(LinearGradient);

export const DEFAULT_HORIZONTAL_GRADIENT_POSITION: GradientPosition = {
  start: { x: 0, y: 0 },
  end: { x: 1, y: 0 },
};

export const DEFAULT_VERTICAL_GRADIENT_POSITION: GradientPosition = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
};

export type LGradientProps = {
  blurAmount?: number;
  gradientDirection?: "horizontal" | "vertical";
  gradientPosition?: GradientPosition;
  locations?: number[];
};

type Props = AnimatedProps<LinearGradientProps> & LGradientProps;

const Gradient = ({
  children,
  gradientDirection = "vertical",
  gradientPosition,
  ...rest
}: Props) => {
  const internalGradientPosition =
    gradientPosition === undefined
      ? gradientDirection === "horizontal"
        ? DEFAULT_HORIZONTAL_GRADIENT_POSITION
        : DEFAULT_VERTICAL_GRADIENT_POSITION
      : gradientPosition;

  return (
    <AnimatedLinearGradient {...internalGradientPosition} {...rest}>
      {children}
    </AnimatedLinearGradient>
  );
};

const LGradient = createBox<Theme, Props>(Gradient);
export default LGradient;
